import { Button } from '@ordr-as/umami-react/button';
import { FormattedMessage } from 'react-intl';
import type { ListActivePaymentDto, PaymentMethodDto } from '../../../../../../generated-api';
import { CashDrawerStatus, useCashStatus, useShouldDisplayCashButton } from '../../../../../hooks/useCashStatus';
import { useLocation } from '../../../../../context/LocationContext';
import React, { useState } from 'react';
import CashConfirmationDialog from './CashConfirmationDialog';

interface CashButtonProps {
  className: string;
  paymentMethod: PaymentMethodDto;
  handleButtonClick: () => void;
  busy: boolean;
  activePayment?: ListActivePaymentDto;
}

const CashButton = (props: CashButtonProps) => {
  const { className, paymentMethod, handleButtonClick, busy } = props;

  const cashStatus = useCashStatus();

  const [showCashConfirmationDialog, setShowCashConfirmationDialog] = useState(false);

  const { location } = useLocation();
  const shouldDisplayCashButton = useShouldDisplayCashButton(location.countryCode);

  if (!shouldDisplayCashButton) {
    return null;
  }

  const payText =
    location.countryCode === 'UK'
      ? `checkout.paymentButton.newFlow.CASH.connected`
      : `checkout.paymentButton.newFlow.CASH.${cashStatus}`;

  return (
    <>
      <Button
        className={className}
        kind="secondary"
        key={paymentMethod.paymentMethod + paymentMethod.id}
        onClick={() => {
          setShowCashConfirmationDialog(true);
        }}
        isDisabled={busy || cashStatus === CashDrawerStatus.ERROR || cashStatus === CashDrawerStatus.DISCONNECTED}
      >
        <p>
          <b>
            <FormattedMessage id={payText} />
          </b>
        </p>
        <div className="truncate-2">
          <FormattedMessage id="checkout.paymentButton.newFlow.CASH" />
        </div>
      </Button>

      {showCashConfirmationDialog && (
        <CashConfirmationDialog
          onContinue={() => {
            setShowCashConfirmationDialog(false);
            handleButtonClick();
          }}
          onClose={() => {
            setShowCashConfirmationDialog(false);
          }}
        />
      )}
    </>
  );
};

export default React.memo(CashButton);
